import React from 'react';
import PropTypes from 'prop-types';
import { FaRedoAlt } from 'react-icons/fa';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../../constants';
const ResetDesktopForm = ({
  handleReset
}) => {
  const {
    t
  } = useTranslation(TRANSLATION_NAMESPACE);
  return /*#__PURE__*/React.createElement("div", {
    className: "filter__reset"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "icon-button icon-button--reset",
    title: "reset--button",
    "data-testid": "reset-icon",
    onClick: handleReset,
    "aria-label": t('RESET_ALL_FILTERS')
  }, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(FaRedoAlt, null))), /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: handleReset,
    "data-testid": "reset-button"
  }, t('RESET_ALL_FILTERS')));
};
ResetDesktopForm.propTypes = {
  handleReset: PropTypes.func.isRequired
};
export default ResetDesktopForm;
//# sourceMappingURL=ResetDesktopForm.js.map